import React, { useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import moment from "moment"
import { Link } from "react-router-dom"
import { useQuery } from "@apollo/client"
import Spinner from "../Spinner/Spinner"
import Tooltip from '../Tooltip/Tooltip'
import { serialize } from "../../../utils"
import { GET_ANNOUNCES } from "../../../graphql/index"
import { INITIAL_HISTORY } from "../../../constant"
import css from './Schedule.module.scss'
import lCss from '../../Layout/Layout.module.scss'

export default function Schedule({title = 'День в истории', variables = INITIAL_HISTORY, tooltip = null, dataTarget = ''}){
	const { loading, data } = useQuery(GET_ANNOUNCES,{variables: serialize(variables)})

    return (
        <div className={css.block} data-target={dataTarget}>
            <div className={css.header}>
	            {title}
	            {tooltip ? <Tooltip text={tooltip}/> : null}
            </div>
            <div className={css.list}>
	            {loading ? <Spinner/> : null}
	            {data?.announces?.map((item) => {
		            return <div className={css.item} key={item.article_id}>
			            <Link to={'/event/' + item.article_id} className={css.title}>{item.article_title}</Link>
		            </div>
	            })}
	            {(!data?.announces?.length && !loading) ? <div className={css.empty}>Ничего не найдено</div> : null}
            </div>
	        {!loading && data?.announces?.length && variables?.fd ? <Link to={'/history' + '?fd='+ moment(variables?.fd).format('YYYYMMDD')} className={lCss.button + ' ' + lCss.w100 + ' '+ lCss.mt20}>Смотреть все события</Link> : null}
        </div>
    )
}